module.exports = __webpack_public_path__ + "static/media/market-login1.8275aa7e.jpg";